export function loadScript(id, src, onLoad, options) {
    if (typeof document !== 'undefined') {
        const element = document.getElementById(id);
        if (!element) {
            const script = document.createElement('script');
            script.id = id;
            script.src = src;
            if (options === null || options === void 0 ? void 0 : options.crossorigin) {
                script.crossOrigin = options.crossorigin;
            }
            if (onLoad) {
                script.onload = onLoad;
            }
            document.body.appendChild(script);
        } else {
            onLoad && onLoad();
        }
    }
}
